import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type DashboardSortingType = {
    id: string;
    desc: boolean;
};

export const initialState: DashboardSortingType = {
    id: 'referredDate',
    desc: true,
};

export const dashboardSorting = createSlice({
    name: 'dashboardSorting',
    reducers: {
        updateSorting: (state, action: PayloadAction<{ id: string; desc: boolean }>) => {
            state.id = action.payload.id;
            state.desc = action.payload.desc;
        },
    },
    initialState,
});

export const { updateSorting } = dashboardSorting.actions;

export default dashboardSorting.reducer;
